"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.5757143,5.80642857 L16.7642857,5.80642857 L16.7642857,4.85357143 C16.7642857,3.28135714 15.4779286,1.995 13.9057143,1.995 L10.0942857,1.995 C8.52207143,1.995 7.23571429,3.28135714 7.23571429,4.85357143 L7.23571429,5.80642857 L3.42428571,5.80642857 C2.90021429,5.80642857 2.47142857,6.23521429 2.47142857,6.75928571 C2.47142857,7.28335714 2.90021429,7.71214286 3.42428571,7.71214286 L4.37714286,7.71214286 L4.37714286,19.1464286 C4.37714286,20.7186429 5.6635,22.005 7.23571429,22.005 L16.7642857,22.005 C18.3365,22.005 19.6228571,20.7186429 19.6228571,19.1464286 L19.6228571,7.71214286 L20.5757143,7.71214286 C21.0997857,7.71214286 21.5285714,7.28335714 21.5285714,6.75928571 C21.5285714,6.23521429 21.0997857,5.80642857 20.5757143,5.80642857 Z M9.14142857,4.85357143 C9.14142857,4.3295 9.57021429,3.90071429 10.0942857,3.90071429 L13.9057143,3.90071429 C14.4297857,3.90071429 14.8585714,4.3295 14.8585714,4.85357143 L14.8585714,5.80642857 L9.14142857,5.80642857 L9.14142857,4.85357143 Z M17.7171429,19.1464286 C17.7171429,19.6705 17.2883571,20.0992857 16.7642857,20.0992857 L7.23571429,20.0992857 C6.71164286,20.0992857 6.28285714,19.6705 6.28285714,19.1464286 L6.28285714,7.71214286 L17.7171429,7.71214286 L17.7171429,19.1464286 Z"
  });
}.bind(void 0));

exports.default = _default;